import { axiosClientv1 } from "./apiClient";
import { ApiResponse } from "../Types";

export interface PolicyOverrideMap {
  [policyPath: string]: string[];
}

export interface PolicyDefaultsMap {
  [policyPath: string]: string[];
}

export const GetAccessPolicyOverrides = async (): Promise<
  ApiResponse<{ defaults: PolicyDefaultsMap; overrides: PolicyOverrideMap }>
> => {
  try {
    const response = await axiosClientv1.get(`/access-policies`);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message || "Failed to load access policies.",
      data: { defaults: {}, overrides: {} },
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};

export interface SectionPolicyEntry {
  default: string[];
  current: string[];
}

export interface SectionPolicyResponse {
  section: string;
  policies: Record<string, SectionPolicyEntry>;
}

export const GetSectionAccess = async (
  section: string,
): Promise<ApiResponse<SectionPolicyResponse>> => {
  try {
    const response = await axiosClientv1.get(`/access-policies/section`, {
      params: { name: section },
    });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message || "Failed to load section policies.",
      data: { section, policies: {} },
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};

export const SaveAccessPolicyOverrides = async (payload: {
  overrides: PolicyOverrideMap;
}): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.put(`/access-policies`, payload);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message || "Failed to save access policies.",
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};
